<template>
    <div class="flex space-x-2 items-center justify-center">
        <fa-icon v-if="icon" :icon="icon"></fa-icon>
        <span><slot></slot></span>
    </div>
</template>

<script setup>
const props     = defineProps({
    icon: String,
})
</script>